import React from 'react';
import { tracer } from './services/telemetry/otel';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './assets/styles.css';
import './assets/fonts.css';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import { initPostHog } from './services/posthog/init';
import { canonicaliseUrlLocale } from './utils/translation/country';
import { log } from '@domgen/shared/utils/log';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const renderApp = () => {
  createRoot(container).render(
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </React.StrictMode>,
  );
};

const bootstrap = async () => {
  // A mis-cased `?lang=` (Beko's redirect sends `es-es`) is rewritten to its
  // canonical form first, so PostHog's first event and the app both see `es-ES`.
  canonicaliseUrlLocale();
  await initPostHog({
    brand: import.meta.env.VITE_BRAND_CODE,
    // Registered as a super-property on every event so this deployment's
    // traffic can be segmented from the original OLR sites in a shared
    // PostHog project (e.g. 'eu-sandbox-poc').
    source: import.meta.env.VITE_POSTHOG_SOURCE,
  }).catch((e) => log.info({ message: 'Error initializing PostHog', data: e }));
  renderApp();
};

bootstrap();
if (typeof window !== 'undefined') {
  tracer();
}
